import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverHeight = size === 'large' ? 'h-72' : size === 'small' ? 'h-48' : 'h-60';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative ${coverHeight} overflow-hidden`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        {comic.status && (
          <span
            className={`absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-accent-500 text-white'
                : 'bg-secondary-500 text-white'
            }`}
          >
            {comic.status}
          </span>
        )}
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-2 text-white text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-400 w-3 h-3 flex items-center justify-center"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
              {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
            </span>
            <span className="flex items-center gap-1 ml-auto">
              <i className="ri-file-list-3-line w-3 h-3 flex items-center justify-center"></i>
              {comic.chapters}话
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors truncate">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        {size !== 'small' && comic.tags && (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {comic.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}